import { getUnique } from "src/utils/restFunction";
import axios from "axios";
import { strapiUrl, strapiCheckUrl } from "src/modules/users/constants";
import { prefix } from "src/utils/users.utils";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";
import { resolveResourceUrl } from "src/utils/url.utils";

export const searchPeopleRequest = async (name: string, limit = 100) => {
  name = (name && name.replace("*", "")) || "";
  let token: string | null = null;

  if (!isPWA()) {
    const result = await SecureStoragePlugin.get({ key: 'accessToken' });
    token = result.value;
  }

  const headers = {
    Accept: "application/json;odata=nometadata",
    "Content-Type": "application/json;odata=nometadata",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const response = await axios.get(`${strapiUrl}custom-users`, {
    params: {
      pagination: {
        page: 1,
        pageSize: 100,
      },
      filters: {
        $or: [
          { Name: { $containsi: name || "Сначала нужно ввести значение" } },
          {
            PersonalNumber: {
              $containsi: name || "Сначала нужно ввести значение",
            },
          },
          {
            email: {
              $containsi: (!name && "@") || "Сначала нужно ввести значение",
            },
          },
        ],
        blocked: false,
      },
      fields: ["email", "PersonalNumber", "Name"],
      populate: {
        ManagerDev: {
          fields: ["Name"],
        },
        PictureUrl: {
          fields: ["url"],
        },
      },
    },
    headers,
    withCredentials: true,
  });
  let returnData: any = [];
  response.data.data.forEach((user: any) => {
    returnData = [
      ...returnData,
      {
        id: user.id,
        FirstName: user.Name.split(" ")[1],
        LastName: user.Name.split(" ")[0],
        AccountName: prefix + user.email,
        apiGlobalID: user.PersonalNumber,
        abiGlobalID: user.PersonalNumber,
        PictureUrl: (user.PictureUrl && resolveResourceUrl(user.PictureUrl.url, strapiCheckUrl)) || null,
        UserName: user.PersonalNumber,
        PreferredName: user.Name,
        ManagerFullNameRUS: (user.ManagerDev && prefix + user.ManagerDev.Name) || null,
      },
    ];
  });
  return returnData;

};

type TitleType = "name" | "title";

export const fetchSearchByKey = async (query: string, fetchKey: string, defaultExportKey: TitleType = "name") => {
  let key = "";
  switch (fetchKey) {
    case "FirstName":
      key = "Name";
      break;
    case "LastName":
      key = "Name";
      break;
    case "PreferredName":
      key = "Name";
      break;
    case "PreferredNameRUS":
      key = "Name";
      break;
    case "TitleRUS":
      key = "Position";
      break;
    case "JobTitleRus":
      key = "Position";
      break;
    case "JobTitle":
      key = "Position";
      break;
    case "DepartmentRUS":
      key = "Department";
      break;
    case "SPS-Location":
      key = "Location";
      break;
    case "Region":
      key = "Location";
      break;
    case "BaseOfficeLocation":
      key = "Location";
      break;
    case "WorkEmail":
      key = "email";
      break;
    case "AccountName":
      key = "email";
      break;
    case "apiGlobalID":
      key = "PersonalNumber";
      break;
    default:
      key = fetchKey;
  }
  // const token = sessionStorage.getItem("accessToken");
  const { value: token } = await SecureStoragePlugin.get({ key: 'accessToken' });
  const response = await axios.get(`${strapiUrl}custom-users`, {
    params: {
      pagination: {
        page: 1,
        pageSize: 100,
      },
      filters: {
        $or: [
          { [key]: { $containsi: query || "Сначала нужно ввести значение" } },
          {
            email: {
              $containsi: (!query && "@") || "Сначало нужно ввести значение",
            },
          },
        ],
        blocked: false,
      },
      fields: ["id", "username", "email", "PersonalNumber", "City", "Name", "Position", "Location", "Department"],
      populate: {
        ManagerDev: {
          fields: ["Name"],
        },
        PictureUrl: {
          fields: ["url"],
        },
      },
    },
    headers: {
      Accept: "application/json;odata=nometadata",
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
  });
  let returnData: any = [];
  response.data.data.forEach((user: any) => {
    returnData = [
      ...returnData,
      {
        FirstName: user.Name.split(" ")[1],
        LastName: user.Name.split(" ")[0],
        AccountName: prefix + user.email,
        apiGlobalID: user.PersonalNumber,
        abiGlobalID: user.PersonalNumber,
        PictureUrl: (user.PictureUrl && resolveResourceUrl(user.PictureUrl.url, strapiCheckUrl)) || null,
        UserName: user.PersonalNumber,
        PreferredName: user.Name,
        PreferredNameRUS: user.Name,
        TitleRUS: user.Position,
        JobTitleRus: user.Position,
        JobTitle: user.Position,
        "SPS-Location": user.Location,
        Region: user.Location,
        DepartmentRUS: user.Department,
        Department: user.Department,
        BaseOfficeLocation: user.Location,
        WorkEmail: user.email,
        ManagerFullNameRUS: (user.ManagerDev && prefix + user.ManagerDev.Name) || null,
      },
    ];
  });
  const result: string[] = getUnique(returnData, fetchKey);
  return result.map((r) => ({
    [defaultExportKey]: r || "No Data",
    id: r || Date.now(),
  })) as [];
};
